import React, { Component } from 'react';
import { DetailsList, SelectionMode, Selection, ConstrainMode } from 'office-ui-fabric-react/lib/DetailsList';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataContact } from '../../data/DataContact';

/*
***************************************************************
 PROPS:
    onSelection: méthode exécutée par le formualire appelant lors de la sélection du contact

    civilite: propriété
    nom: propriété
    prenom: propriété
    cp: propriété
    email: propriété
    tel1: propriété

***************************************************************
*/

export class DetailsListContactDedoublonne extends Component {
    _creationContent() {
        const { items } = this.state;

        return (
            <DetailsList
                items={items}
                columns={this.columns}
                selectionMode={SelectionMode.single}
                selection={this._selection}
                constrainMode={ConstrainMode.unconstrained}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onRenderItemColumn={this._onRenderItemColumn}
            />
        );
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails()
                });
            }
        });

        this.state = {
            items: [],
            idContactSelectionne: 0,

            civilite: '',
            nom: '',
            prenom: '',
            cp: '',
            email: '',
            tel1: ''
        };

        //#region chargement des columns
        let columnsTemp = [];
        //columnsTemp.push({
        //    key: 'idContact',
        //    name: 'ID',
        //    fieldName: 'idContact',
        //    minWidth: 50,
        //    maxWidth: 50,
        //    isResizable: true,
        //    className: 'ms-hiddenLgDown',
        //    headerClassName: 'ms-hiddenLgDown',

        //    onRender: (item) => {
        //        let idContact = item.idContact;
        //        return <span title={'n°' + idContact}>{idContact}</span>;
        //    }
        //});
        columnsTemp.push({
            key: 'nom',
            name: 'Nom',
            fieldName: 'nom',
            minWidth: 100,
            maxWidth: 500,
            isResizable: true,
            //className: 'ms-hiddenLgUp ms-hiddenMdDown',
            //headerClassName: 'ms-hiddenLgUp ms-hiddenMdDown',

            onRender: (item) => {
                let nom = item.nom;
                if (item.idContact !== null) {
                    return <span title={nom}>{nom}</span>;
                }
                else {
                    return <span title={nom}>'Nouveau contact : ' {nom}</span>;
                }
            }
        });
        columnsTemp.push({
            key: 'prenom',
            name: 'Prénom',
            fieldName: 'prenom',
            minWidth: 100,
            maxWidth: 500,
            isResizable: true,
            //className: 'ms-hiddenLgUp ms-hiddenMdDown',
            //headerClassName: 'ms-hiddenLgUp ms-hiddenMdDown',

            onRender: (item) => {
                let prenom = item.prenom;
                return <span title={prenom}>{prenom}</span>;
            }
        });
        columnsTemp.push({
            key: 'cp',
            name: 'CP',
            fieldName: 'cp',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',

            onRender: (item) => {
                let cp = item.cp;
                return <span title={cp}>{cp}</span>;
            }
        });
        columnsTemp.push({
            key: 'ville',
            name: 'Ville',
            fieldName: 'ville',
            minWidth: 100,
            maxWidth: 300,
            isResizable: true,
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',

            onRender: (item) => {
                let ville = item.ville;
                return <span title={ville}>{ville}</span>;
            }
        });
        columnsTemp.push({
            key: 'datenaissance',
            name: 'Date de naissance',
            fieldName: 'Né(e) le',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',

            onRender: (item) => {
                let datenaissance = Scriba.date().stringDateFormatCourt(item.datenaissance);
                return <span title={datenaissance}>{datenaissance}</span>;
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }
    _getItems = () => {
        return [];

    }
    _getFarItems = () => {
        return [];

    }
    _chargementDonnees(civilite, nom, prenom, cp, email, tel1) {
        let contact = {};
        contact.civilite = civilite;
        contact.nom = nom;
        contact.prenom = prenom;
        contact.cp = cp;
        contact.email = email;
        contact.tel1 = tel1;

        let onGetSiContactExiste = DataContact._onGetSiContactExiste(contact);

        onGetSiContactExiste
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);

                    this.setState({
                        items: listeItem,
                        civilite: civilite,
                        nom: nom,
                        prenom: prenom,
                        cp: cp,
                        email: email,
                        tel1: tel1,

                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',

                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage,
                        hideMessageBarFiltres: (responseFetch.messageInfo === "" || responseFetch.messageInfo === null),
                        messageMessageBarFiltres: responseFetch.messageInfo
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.civilite = '';
                    stateTemp.nom = '';
                    stateTemp.prenom = '';
                    stateTemp.cp = '';
                    stateTemp.email = '';
                    stateTemp.tel1 = '';

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _getSelectionDetails() {
        const selectionCount = this._selection.getSelectedCount();
        let itemSelectionne = null;

        switch (selectionCount) {
            case 0:
                this.setState({
                    idContactSelectionne: 0
                });
                break;
            case 1:
                itemSelectionne = this._selection.getSelection()[0];

                this.props.onSelection((itemSelectionne).idContact);
                break;
            default:
                break;
        }
    }

    _onSelectionContact = () => {
        this.props.onSelection(this.state.idContactSelectionne);
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    componentDidUpdate() {
        if (
            (this.props.civilite != null & this.props.nom != null & this.props.prenom != null & this.props.cp != null) & // & this.props.datenaissance != null) &
            (this.props.civilite !== this.state.civilite & this.props.nom !== this.state.nom & this.props.prenom !== this.state.prenom & this.props.cp !== this.state.cp)
        ) // & this.props.datenaissance !== this.state.datenaissance)) {
        {
            this._chargementDonnees(this.props.civilite, this.props.nom, this.props.prenom, this.props.cp, this.props.email, this.props.tel1);//, this.props.datenaissance);
        }
    }

    componentWillUnmount() {
    }

    render() {
        let content = this._creationContent();

        return (<div>{content}</div>);
    }
}